import { MuiChip } from '@/components/chip/MuiChip';
import { Box, SxProps } from '@mui/material';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

type Props = {
  sxProps?: SxProps;
};

export function PartnerBadge({ sxProps }: Props) {
  return (
    <MuiChip
      label="地域連携"
      icon={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            ml: '6px',
          }}
        >
          <HandshakeOutlinedIcon sx={{ fontSize: 16, color: '#33BEB9' }} />
        </Box>
      }
      sx={{
        backgroundColor: '#E8FAF9',
        borderRadius: '4px',
        typography: 'JP/Body/m/Medium/None',
        padding: '0px 4px',
        height: '30px',
        color: '#33BEB9',
        '& .MuiChip-label': {
          marginBottom: '2px',
          paddingLeft: '4px',
          paddingRight: '4px',
        },
        '& .MuiChip-icon': {
          margin: 0,
        },
        ...sxProps,
      }}
    />
  );
}
